module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [_c('slider', {
    attrs: {
      "pages": _vm.focus
    }
  }), _vm._v(" "), _c('album'), _vm._v(" "), _c('hotdiss', {
    attrs: {
      "disslist": _vm.hotdissList
    }
  }), _vm._v(" "), _c('shoubomv', {
    attrs: {
      "mvlist": _vm.shoubomv
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-10b96057"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index/index.vue
// module id = 155
// module chunks = 1